module.exports = __webpack_public_path__ + "static/benefit-1-2c8c236b06ff84e79679bc52f624a4fa.png";